const NEW_BUILDING_ID = Symbol('new building id');
const NEW_LABEL_ID = Symbol('new label id');

export {
  NEW_BUILDING_ID,
  NEW_LABEL_ID,
};
